import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  entryNote: string[];
};

export const EntryNote: FC<Props> = ({ entryNote }) => {
  return (
    <GuidanceBox themeColor="pink">
      <div className={styles.entryNoteHeaderWrapper}>
        <div className={styles.iconWrapper}>
          <Icon fontSize="16px" name="keep-star" />
        </div>
        <p className={styles.entryNoteHeader}>エントリーの注意事項</p>
      </div>
      <ul className={styles.list}>
        {entryNote.map((note) => (
          <li key={note} className={styles.dotListItem}>
            {note}
          </li>
        ))}
      </ul>
    </GuidanceBox>
  );
};
